<div #layerTooltip class="layer-tooltip">
    <label class="toggle-switch modifier-class">
        <input type="checkbox" [(ngModel)]="tooltipEnabled">
        <span class="togggle-switch-label font-size--1">Tooltip</span>        
    </label>
</div>
